import { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridTopHeader } from "../../../../components/styled";
import { departmentTableColumns } from "../../../../data/mockTableColumns";
import { getAllDepartments, deleteDepartment } from "../../../../api/department";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";
import ActionButton from "../../../../components/shared/ActionButton";
import CreateDepartmentModal from "../../../../components/models/CreateDepartmentModal";
// import Snackbar from "../../../../components/shared/Snackbar";

const Departments = () => {
  const [departments, setDepartments] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const fetchAllDepartments = async () => {
      try {
        const allDepartments = await getAllDepartments();
        setDepartments(allDepartments);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchAllDepartments();
  }, []);

  // const handleDeleteDepartment = async (id) => {
  //   try {
  //     await deleteDepartment();
  //     <Snackbar message='Department Deleted Successfully.' />
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // } 

  // Filtered departments based on search query
  const filteredDepartments = departments.filter((department) =>
    department.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <DashboardLayout>
      <Box display="flex" justifyContent="end">
        <ActionButton
          colors={colors}
          title="Add Department"
          icon={<AddIcon />}
          onClick={() => setOpenModal(true)}
        />
      </Box>

      <DashboardHeader
        title="Departments"
        subtitle="List of All Departments"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <DataGridTopHeader theme={theme}>
        <DataGrid
          rows={filteredDepartments}
          columns={departmentTableColumns}
          getRowId={(row) => row._id}
          checkboxSelection
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 30]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </DataGridTopHeader>

      {openModal && (
        <CreateDepartmentModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          colors={colors}
        />
      )}
    </DashboardLayout>
  );
};

export default Departments;
